"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduledMailDialogRenderer = exports.ScheduledMailDialogRendererIntl = exports.ScheduledMailDialogRendererUI = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var React = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var memoize_1 = tslib_1.__importDefault(require("lodash/memoize"));
var constants_1 = require("../constants");
var interfaces_1 = require("../interfaces");
var repeat_1 = require("../utils/repeat");
var scheduledMailSummary_1 = require("../utils/scheduledMailSummary");
var scheduledMailRecipients_1 = require("../utils/scheduledMailRecipients");
var timezone_1 = require("../utils/timezone");
var datetime_1 = require("../utils/datetime");
var validate_1 = require("../utils/validate");
var Textarea_1 = require("./Textarea");
var RepeatSelect_1 = require("./RepeatSelect/RepeatSelect");
var Input_1 = require("./Input");
var DateTime_1 = require("./DateTime");
var Attachment_1 = require("./Attachment");
var RecipientsSelect_1 = require("./RecipientsSelect/RecipientsSelect");
var internalIntlProvider_1 = require("../../../utils/internalIntlProvider");
var MAX_MESSAGE_LENGTH = 200;
var MAX_SUBJECT_LENGTH = 200;
var MAX_DASHBOARD_TITLE_LENGTH = constants_1.DASHBOARD_TITLE_MAX_LENGTH;
var MAX_HYPHEN_LENGTH = 3;
var userToRecipient = memoize_1.default(function (user) { return ({
    user: user,
}); });
var ScheduledMailDialogRendererUI = /** @class */ (function (_super) {
    tslib_1.__extends(ScheduledMailDialogRendererUI, _super);
    function ScheduledMailDialogRendererUI(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.onAlign = function (alignment) {
            if (alignment.top < 0) {
                _this.setState({ alignment: "tc tc" });
            }
        };
        _this.renderAttachment = function () {
            var intl = _this.props.intl;
            var defaultEmailSubject = _this.getDefaultSubject();
            var fileName = defaultEmailSubject + ".pdf";
            return (React.createElement(Attachment_1.Attachment, { className: "s-gd-schedule-email-dialog-attachment", label: intl.formatMessage({ id: "dialogs.schedule.email.attachment.label" }), fileName: fileName }));
        };
        _this.renderDateTime = function () {
            var _a = _this.props, dateFormat = _a.dateFormat, intl = _a.intl, locale = _a.locale;
            var _b = _this.repeatData, date = _b.date, time = _b.time;
            var sendDate = new Date(date.year, date.month - 1, date.day, time.hour, time.minute);
            return (React.createElement(DateTime_1.DateTime, { date: sendDate, dateFormat: dateFormat, label: intl.formatMessage({ id: "dialogs.schedule.email.time.label" }), locale: locale, timezone: _this.userTimezone.title, onDateChange: _this.onDateChange, onTimeChange: _this.onTimeChange }));
        };
        _this.renderMessage = function () {
            var intl = _this.props.intl;
            var defaultEmailBody = _this.getDefaultEmailBody();
            return (React.createElement(Textarea_1.Textarea, { className: "s-gd-schedule-email-dialog-message", label: intl.formatMessage({ id: "dialogs.schedule.email.message.label" }), maxlength: MAX_MESSAGE_LENGTH, placeholder: defaultEmailBody, rows: 4, onChange: _this.onMessageChange }));
        };
        _this.renderRecipients = function () {
            var selectedRecipients = _this.state.selectedRecipients;
            var _a = _this.props, backend = _a.backend, workspace = _a.workspace, canListUsersInProject = _a.canListUsersInProject, enableKPIDashboardScheduleRecipients = _a.enableKPIDashboardScheduleRecipients, currentUser = _a.currentUser;
            return (React.createElement(RecipientsSelect_1.RecipientsSelect, { currentUser: userToRecipient(currentUser), canListUsersInProject: canListUsersInProject, enableKPIDashboardScheduleRecipients: enableKPIDashboardScheduleRecipients, value: selectedRecipients, onChange: _this.onRecipientsChange, onError: _this.props.onError, backend: backend, workspace: workspace }));
        };
        _this.renderRepeats = function () {
            var intl = _this.props.intl;
            var startDate = _this.state.startDate;
            return (React.createElement(RepeatSelect_1.RepeatSelect, { label: intl.formatMessage({ id: "dialogs.schedule.email.repeats.label" }), repeatExecuteOn: constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH, repeatFrequency: constants_1.REPEAT_FREQUENCIES.DAY, repeatPeriod: constants_1.DEFAULT_REPEAT_PERIOD, repeatType: constants_1.REPEAT_TYPES.DAILY, startDate: startDate, onChange: _this.onRepeatsChange }));
        };
        _this.renderSubject = function () {
            var intl = _this.props.intl;
            var defaultEmailSubject = _this.getDefaultSubject();
            return (React.createElement(Input_1.Input, { className: "s-gd-schedule-email-dialog-subject", label: intl.formatMessage({ id: "dialogs.schedule.email.subject.label" }), maxlength: MAX_SUBJECT_LENGTH, placeholder: defaultEmailSubject, onChange: _this.onSubjectChange }));
        };
        // Listeners
        _this.onScheduleDialogSubmit = function () {
            var onSubmit = _this.props.onSubmit;
            if (onSubmit) {
                onSubmit(_this.getScheduleEmailData());
            }
        };
        _this.onDateChange = function (selectedDateObject) {
            _this.repeatData.date = {
                day: datetime_1.getDate(selectedDateObject),
                month: datetime_1.getMonth(selectedDateObject),
                year: datetime_1.getYear(selectedDateObject),
            };
            _this.setState({ startDate: selectedDateObject }, function () {
                _this.updateStartDateForRepeats(selectedDateObject);
            });
        };
        _this.onTimeChange = function (time) {
            _this.repeatData.time = time;
            _this.setState({
                startTime: time,
            });
        };
        _this.onRecipientsChange = function (selectedRecipients) {
            var isValidScheduleEmailData = selectedRecipients
                .map(scheduledMailRecipients_1.getScheduledEmailRecipientEmail)
                .every(validate_1.isEmail);
            _this.setState({
                selectedRecipients: selectedRecipients,
                isValidScheduleEmailData: isValidScheduleEmailData,
            });
        };
        _this.onMessageChange = function (value) {
            _this.emailBody = value;
        };
        _this.onRepeatsChange = function (data) {
            var repeatExecuteOn = data.repeatExecuteOn, repeatFrequency = data.repeatFrequency, repeatPeriod = data.repeatPeriod, repeatType = data.repeatType;
            var startDate = _this.state.startDate;
            _this.repeatData.repeatPeriod = repeatPeriod;
            _this.repeatData.repeatType = repeatType;
            if (repeatType === constants_1.REPEAT_TYPES.CUSTOM) {
                if (repeatFrequency === constants_1.REPEAT_FREQUENCIES.MONTH) {
                    repeat_1.setMonthlyRepeat(_this.repeatData, repeatExecuteOn, startDate);
                }
                else if (repeatFrequency === constants_1.REPEAT_FREQUENCIES.WEEK) {
                    repeat_1.setWeeklyRepeat(_this.repeatData, startDate);
                }
                else {
                    repeat_1.setDailyRepeat(_this.repeatData);
                }
            }
            else if (repeatType === constants_1.REPEAT_TYPES.MONTHLY) {
                repeat_1.setMonthlyRepeat(_this.repeatData, constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK, startDate);
            }
            else if (repeatType === constants_1.REPEAT_TYPES.WEEKLY) {
                repeat_1.setWeeklyRepeat(_this.repeatData, startDate);
            }
            else {
                repeat_1.setDailyRepeat(_this.repeatData);
            }
        };
        _this.onSubjectChange = function (value) {
            _this.emailSubject = value;
        };
        // Internal utils
        _this.getDefaultSubject = function () {
            var _a = _this.props, dashboardTitle = _a.dashboardTitle, dateFormat = _a.dateFormat;
            var startDate = _this.state.startDate;
            var displayDateString = datetime_1.convertDateToDisplayDateString(startDate, dateFormat);
            var dashboardTitleMaxLength = _this.getDashboardTitleMaxLength(displayDateString);
            var isDashboardTitleTooLong = dashboardTitle.length > dashboardTitleMaxLength;
            var truncatedDashboardTitle = isDashboardTitleTooLong
                ? dashboardTitle.substring(0, dashboardTitleMaxLength)
                : dashboardTitle;
            return truncatedDashboardTitle + " - " + displayDateString;
        };
        _this.getDefaultEmailBody = function () {
            var intl = _this.props.intl;
            return intl.formatMessage({
                id: "dialogs.schedule.email.message.placeholder",
            });
        };
        _this.getScheduleEmailData = function () {
            var when = _this.getTimeSchedule();
            var recipients = _this.state.selectedRecipients;
            /// To: is currently only owner
            var toEmails = recipients
                .filter(interfaces_1.isScheduleEmailExistingRecipient)
                .map(function (recipient) { return recipient.user.login; });
            /// All other emails (without owner)
            var bccEmails = recipients
                .filter(interfaces_1.isScheduleEmailExternalRecipient)
                .map(function (recipient) { return recipient.email; });
            var dashboard = _this.props.dashboard;
            var _a = _this, emailSubject = _a.emailSubject, emailBody = _a.emailBody;
            var subject = emailSubject || _this.getDefaultSubject();
            var body = emailBody || _this.getDefaultEmailBody();
            var description = _this.getSummaryMessage();
            return {
                when: when,
                to: toEmails,
                bcc: bccEmails,
                subject: subject,
                body: body,
                attachments: [
                    {
                        dashboard: dashboard,
                        format: "pdf",
                    },
                ],
                description: description,
                title: subject,
                // Every scheduled email is private for the logged in user.
                unlisted: true,
            };
        };
        _this.getTimeSchedule = function () {
            var recurrence = repeat_1.generateRepeatString(_this.repeatData);
            var startDate = datetime_1.convertDateToPlatformDateString(_this.state.startDate);
            return {
                recurrence: recurrence,
                startDate: startDate,
                timeZone: _this.userTimezone.identifier,
            };
        };
        _this.getSummaryMessage = function () {
            var _a = _this, intl = _a.props.intl, startDate = _a.state.startDate, repeatData = _a.repeatData;
            return scheduledMailSummary_1.getScheduledEmailSummaryString(intl, {
                repeatData: repeatData,
                startDate: startDate,
            });
        };
        var now = new Date();
        var normalizedTime = sdk_ui_kit_1.normalizeTime(now);
        _this.state = {
            alignment: "cc cc",
            startDate: now,
            startTime: {
                hour: normalizedTime.getHours(),
                minute: normalizedTime.getMinutes(),
                second: 0,
            },
            selectedRecipients: [userToRecipient(_this.props.currentUser)],
            isValidScheduleEmailData: true,
        };
        _this.repeatData = {
            date: {
                day: datetime_1.getDate(now),
                month: datetime_1.getMonth(now),
                year: datetime_1.getYear(now),
            },
            repeatExecuteOn: constants_1.REPEAT_EXECUTE_ON.DAY_OF_MONTH,
            repeatFrequency: (_a = {},
                _a[constants_1.REPEAT_FREQUENCIES.DAY] = true,
                _a),
            repeatPeriod: constants_1.DEFAULT_REPEAT_PERIOD,
            repeatType: constants_1.REPEAT_TYPES.DAILY,
            time: {
                hour: normalizedTime.getHours(),
                minute: normalizedTime.getMinutes(),
                second: 0,
            },
        };
        _this.userTimezone = timezone_1.getUserTimezone();
        _this.emailSubject = "";
        _this.emailBody = "";
        return _this;
    }
    ScheduledMailDialogRendererUI.prototype.render = function () {
        var _a = this.props, intl = _a.intl, onCancel = _a.onCancel;
        var alignPoints = [
            {
                align: this.state.alignment,
            },
        ];
        return (React.createElement(sdk_ui_kit_1.Overlay, { alignPoints: alignPoints, className: "gd-schedule-email-dialog-overlay", isModal: true, positionType: "fixed", onAlign: this.onAlign },
            React.createElement(sdk_ui_kit_1.ConfirmDialogBase, { className: "gd-schedule-email-dialog s-gd-schedule-email-dialog", isPositive: true, headline: intl.formatMessage({ id: "dialogs.schedule.email.headline" }), cancelButtonText: intl.formatMessage({ id: "cancel" }), submitButtonText: intl.formatMessage({ id: "dialogs.schedule.email.submit" }), isSubmitDisabled: !this.state.isValidScheduleEmailData, submitOnEnterKey: false, onCancel: onCancel, onSubmit: this.onScheduleDialogSubmit },
                this.renderRecipients(),
                this.renderSubject(),
                this.renderMessage(),
                this.renderAttachment(),
                React.createElement("div", { className: "hr" }),
                this.renderDateTime(),
                this.renderRepeats())));
    };
    ScheduledMailDialogRendererUI.prototype.getDashboardTitleMaxLength = function (displayDateString) {
        return MAX_DASHBOARD_TITLE_LENGTH - displayDateString.trim().length - MAX_HYPHEN_LENGTH;
    };
    ScheduledMailDialogRendererUI.prototype.updateStartDateForRepeats = function (startDate) {
        var repeatType = this.repeatData.repeatType;
        var repeatFrequency = this.repeatData.repeatFrequency;
        var repeatExecuteOn = this.repeatData.repeatExecuteOn;
        if (repeatType === constants_1.REPEAT_TYPES.CUSTOM) {
            if (repeatFrequency === constants_1.REPEAT_FREQUENCIES.MONTH) {
                repeat_1.setMonthlyRepeat(this.repeatData, repeatExecuteOn, startDate);
            }
            else if (repeatFrequency === constants_1.REPEAT_FREQUENCIES.WEEK) {
                repeat_1.setWeeklyRepeat(this.repeatData, startDate);
            }
            else {
                repeat_1.setDailyRepeat(this.repeatData);
            }
        }
        else if (repeatType === constants_1.REPEAT_TYPES.MONTHLY) {
            repeat_1.setMonthlyRepeat(this.repeatData, constants_1.REPEAT_EXECUTE_ON.DAY_OF_WEEK, startDate);
        }
        else if (repeatType === constants_1.REPEAT_TYPES.WEEKLY) {
            repeat_1.setWeeklyRepeat(this.repeatData, startDate);
        }
        else {
            repeat_1.setDailyRepeat(this.repeatData);
        }
    };
    ScheduledMailDialogRendererUI.defaultProps = {
        dateFormat: "MM/dd/yyyy",
    };
    return ScheduledMailDialogRendererUI;
}(React.PureComponent));
exports.ScheduledMailDialogRendererUI = ScheduledMailDialogRendererUI;
exports.ScheduledMailDialogRendererIntl = react_intl_1.injectIntl(ScheduledMailDialogRendererUI);
exports.ScheduledMailDialogRenderer = function (props) { return (React.createElement(internalIntlProvider_1.InternalIntlWrapper, { locale: props.locale, workspace: props.workspace },
    React.createElement(exports.ScheduledMailDialogRendererIntl, tslib_1.__assign({}, props)))); };
//# sourceMappingURL=ScheduledMailDialogRenderer.js.map